'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

function currentPage() {
	const path = `${window.location.pathname}${window.location.search}`;
	return {
		path,
		url: window.location.href,
		title: document.title || '',
	};
}

function trackGa4(gaId, page) {
	if (!gaId || typeof window.gtag !== 'function') return;
	window.gtag('event', 'page_view', {
		page_title: page.title,
		page_location: page.url,
		page_path: page.path,
		send_to: gaId,
	});
}

function trackMarfeel(page) {
	window.marfeel = window.marfeel || { cmd: [] };
	window.marfeel.cmd.push([
		'compass',
		function (compass) {
			if (compass && typeof compass.trackNewPage === 'function') {
				compass.trackNewPage({ url: page.url });
			}
		},
	]);
}

/**
 * A 1.ª vista já sai dos scripts no `<head>`.
 * Navegações do App Router (sem reload): GA4 e Marfeel não disparam sozinhos.
 * Analytics Pub já faz wrap de pushState/replaceState no abfpush-analytics.js.
 */
export default function SpaPageviewTracker({ gaId }) {
	const pathname = usePathname();
	const isFirst = useRef(true);
	const lastPath = useRef(pathname);

	useEffect(() => {
		if (isFirst.current) {
			isFirst.current = false;
			lastPath.current = pathname;
			return undefined;
		}
		if (pathname === lastPath.current) return undefined;
		lastPath.current = pathname;

		const timer = window.setTimeout(() => {
			const page = currentPage();
			trackGa4(gaId, page);
			trackMarfeel(page);
		}, 50);

		return () => window.clearTimeout(timer);
	}, [pathname, gaId]);

	return null;
}
